module.exports = __webpack_public_path__ + "static/media/frolic.4fec01dc.mp3";